"use strict";
import "lodash";
import { svc_fetchAll, svc_addOne, svc_editOne, svc_deleteOne } from "@/services";
import {
	svc_editBrand,
	svc_editOutlets,
	svc_editPolicies,
	svc_changePassword,
} from "@/services/staff";
import { showServerResponse } from "@/utils/message";
import logger from "@/utils/logger";

const endpointBasePrefix = "staff";

const Model = {
	namespace: "m_Staff",
	state: {
		staff: [],
	},
	reducers: {
		handleFetchAll(state, { payload: { staff } }) {
			return { ...state, staff };
		},
	},
	effects: {
		*fetchAll({ payload }, { call, put }) {
			let staff = yield call(svc_fetchAll, endpointBasePrefix);
			_.forEach(staff, function (row) {
				row.key = row.id;
			});

			yield put({
				type: "handleFetchAll",
				payload: { staff },
			});
		},
		*addOne({ payload }, { call, put }) {
			payload = _.omit(payload, ["key"]);
			const response = yield call(svc_addOne, endpointBasePrefix, payload);
			showServerResponse(response);
			return response;
		},
		*editBrands({ payload }, { call, put }) {
			payload.brands = payload.brands ? payload.brands : [];
			yield call(svc_editBrand, payload.staff_id, payload.brands);
		},
		*editOutlets({ payload }, { call, put }) {
			payload.outlets = payload.outlets ? payload.outlets : [];
			yield call(svc_editOutlets, payload.staff_id, payload.outlets);
		},
		*editPolicies({ payload }, { call, put }) {
			payload.policies = payload.policies ? payload.policies : [];
			yield call(svc_editPolicies, payload.staff_id, payload.policies);
		},
		*changePassword({ payload }, { call, put }) {
			yield call(svc_changePassword, payload.staff_id, payload.password);
		},
		*editOne({ payload }, { call, put }) {
			payload = _.omit(payload, ["key"]);
			const response = yield call(
				svc_editOne,
				endpointBasePrefix,
				payload,
				"staff_id",
				payload.username,
			);
			return showServerResponse(response);
		},
		*resetPassword({ payload }, { call, put }) {
			payload = _.omit(payload, ["key"]);
			const response = yield call(
				svc_editOne,
				`${endpointBasePrefix}/reset_password`,
				payload,
				"id"
			);
			if (response?.serverResponse?.status)
				return showServerResponse(response?.serverResponse);
			else 
			return showServerResponse(response);
		},
		*deleteOne({ payload }, { call, put }) {
			payload = _.omit(payload, ["key"]);
			const response = yield call(
				svc_deleteOne,
				endpointBasePrefix,
				payload,
				"id",
				payload.username,
			);
			return showServerResponse(response);
		},
	},
	subscriptions: {},
};

export default Model;
